import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer  } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { FuncsService } from '../../services/funcs.services';
import * as abc from 'src/assets/js/masonry.pkgd.min.js';
import Masonry from 'masonry-layout';
import * as imagesLoaded from 'src/assets/js/imagesloaded.pkgd.min.js';

@Component({
	selector      : 'app-tab',
	templateUrl   : './tab.component.html',
	encapsulation : ViewEncapsulation.None
})

export class TabComponent implements OnInit {
	@Input() tabData     : any;
	@Input() tabContent  : any;
	@Input() selectedTab : any;
	public engage_data   : any = [];
	public error_message      : any;
	public error_message_show : boolean = false;
	public need_login_view    : boolean = false;
	public isMobile           : boolean;
	public loadButton         : boolean = false;

	constructor(
		private router         : Router,
		private sanitizer      : DomSanitizer,
		private location       : Location,
		private accountService : AccountServiceProvider,
		private funcs          : FuncsService,
	) {
		this.isMobile = this.funcs.globalDetectDevice();
		this.ngAfterViewInit();
	}

	ngOnInit() {}

	addMasonry( querySelectorClass, itemSelectorClass, columnWidthClass, type = null ) {
		var elem = document.querySelector( querySelectorClass );
		if ( '.bi-grid' == querySelectorClass || '.pe-grid' == querySelectorClass ) {
			var pgELemmsnry = new Masonry( elem, {
				itemSelector: itemSelectorClass,
				columnWidth: columnWidthClass,
				horizontalOrder: true,
				percentPosition: true,
			});
		} else {
			var pgELemmsnry = new Masonry( elem, {
				itemSelector: itemSelectorClass,
				columnWidth: columnWidthClass,
				percentPosition: true,
			});
		}
		imagesLoaded( elem ).on( 'progress', function() {
			pgELemmsnry.layout();
		});
		if ( null != type ) {
			pgELemmsnry.on( 'layoutComplete', ()=> {
				pgELemmsnry.layout();
			});
		}
	}

	ngAfterViewInit() {
		let twoColumnCount = document.querySelectorAll( '.component-tab--two-column iframe' );
		if ( 0 < twoColumnCount.length ) {
			[].forEach.call( twoColumnCount, function( el, index ) {
				// create wrapper container
				var wrapper = document.createElement('div');
				// insert wrapper before el in the DOM tree
				el.parentNode.insertBefore(wrapper, el);
				wrapper.className = 'embed-responsive embed-responsive-16by9';
				// move el into wrapper
				wrapper.appendChild(el);
			});
		}
		let youtubeEmbed = document.querySelectorAll( '.embed-container' );
		if ( 0 < youtubeEmbed.length ) {
			[].forEach.call( youtubeEmbed, function( el ) {
				el.classList.remove( 'embed-container' );
				el.classList.add( 'embed-responsive' );
				el.classList.add( 'embed-responsive-16by9' );
			});
			let youtubeIframe = document.querySelectorAll( '.embed-responsive>iframe' );
			if ( 0 < youtubeIframe.length ) {
				[].forEach.call( youtubeIframe, function( ele ) {
					ele.style.width = '100%';
					ele.style.height = '100%';
				});
			}
		}
		if ( document.querySelector( '.participants-grid' ) || document.querySelector( '.team-grid' ) || document.querySelector( '.haf_width' ) || document.querySelector( '.bi-grid' ) || document.querySelector( '.pe-grid' ) ) {
			setTimeout (
				() => {
					if ( document.querySelector( '.participants-grid' ) )
						this.addMasonry( '.participants-grid', '.participants-grid-item', '.grid-sizer-3', 'completelayout' );
					if ( document.querySelector( '.team-grid' ) )
						this.addMasonry( '.team-grid', '.team-grid-item', '.grid-sizer-3', 'completelayout' );
					if ( document.querySelector( '.haf_width' ) )
						this.addMasonry( '.haf_width', '.tab-content__repeater', '.grid-sizer-2' );
					if ( document.querySelector( '.bi-grid' ) ) {
						if ( document.querySelector( '.accordion__repeater' ).classList.contains( '.accordion__opened') ) {
						} else
							this.addMasonry( '.bi-grid', '.bi-grid-item', '.grid-sizer-3')
					}
					if ( document.querySelector( '.pe-grid' ) ) {
						if ( document.querySelector( '.accordion__repeater' ).classList.contains( '.accordion__opened') ) {
						} else
							this.addMasonry( '.pe-grid', '.pe-grid-item', '.grid-sizer' );
					}
				}, 1
			);
		}
	}

	changeCurUrl( url : any, id ) {
		this.loadButton = true;
		sessionStorage.setItem( 'currentPageID', JSON.stringify( id ) );
		this.location.go( url );
		let params = {
			slug : '/' + url,
			id : id,
		}
		this.accountService.getTabData( params ).then( ( response: any ) => {
			if ( 'Ok' === response.status ) {
				if ( 'yes' == response.need_login ) {
					if ( 'userData' in window.localStorage )
						this.pageData( response );
					else {
						sessionStorage.setItem( 'isPageNeedLogin', JSON.stringify( 1 ) );
						this.need_login_view = true;
						this.goToLoginPage();
					}
				} else {
					this.pageData( response );
				}
			}  else {
				this.error_message_show = true;
				if ( '3111' == response.errCode ) {
					this.error_message = 'Oops, looks like something went wrong!';
				} else {
					this.error_message = response.message;
				}
			}
			this.loadButton = false;
		});
		setTimeout (
			() => {
				this.ngAfterViewInit();
			}, 100
		);
	}

	pageData( response ) {
		sessionStorage.setItem( 'isPageNeedLogin', JSON.stringify( 0 ) );
		this.need_login_view = false;
		if ( response.seo_data ) {
			let alternateTitle = response.title;
			this.funcs.globalSeoData( response, alternateTitle );
		}
		this.tabContent.forEach( (item, index ) => {
			if ( item.title == response.title ) {
				if ( 'engage_block' == item.acf_block ) {
					// this.tabContent[index].title = response.title;
					// // this.tabContent[index].engage_content = response.tab_data[0].engage_content;
					// this.tabContent[index].engage_content = response.tab_data.engage_content;
					// this.accountService.getProgrammeTypes().then( ( dotnetresponse: any ) => {
					// 	if ( dotnetresponse.status == 'Ok' ) {
					// 		this.tabContent[index].dotnetprogrammes = dotnetresponse.programmeTypes;
					// 	}
					// });
				} else if( 'tab_content_block' == item.acf_block ) {
					// this.tabContent[index].block_data = response.tab_data[0];
					this.tabContent[index].block_data = response.tab_data;
					// if ( 'saved' == item.block_data.side_block_content_type ) {
					// 	let params = {
					// 		'id' : item.block_data.side_choose_programme_types,
					// 	};
					// 	this.accountService.getProgrameTypeDetail( params ).then( ( response: any ) => {
					// 		if ( 'Ok' == response.status ) {
					// 			this.tabContent[index].pdata = response.programmeTypeDetail;
					// 		}
					// 	});
					// }
				} else {
					// this.tabContent[index].block_data = response.tab_data[0];
					this.tabContent[index].block_data = response.tab_data;
					this.tabContent[index].block_data.forEach( ( tabitem ) => {
						if ( 'imagevideo_block' == tabitem.acf_fc_layout ) {
							if ( 'video' == tabitem.media_type ) {
								tabitem.media_video_repeater.forEach( ( vid ) => {
									vid.iv_video_url = this.sanitizer.bypassSecurityTrustHtml( vid.iv_video_url );
								})
							}
						}
					})
				}
			}
		})
	}

	changeText( event : any, changetext : string ) {
		const changeText = changetext;
		document.getElementById( 'changeText' ).innerHTML = changeText;
	}

	get_color_class( color_code ) {
		if ( '#b0dce0' == color_code )
			return 'color-light-torquoise';
		if ( '#cbebfa' == color_code )
			return 'color-light-blue';
		if ( '#007aac' == color_code )
			return 'color-blue';
		if ( '#68c3cd' == color_code )
			return 'color-torquoise';
	}

	accordion( event : any, classname : string ) {
		let target   = event.target;
		const targetId = target.getAttribute('id');
		target = document.getElementById( targetId );
		const hasClass = target.parentElement.classList.contains( classname );
		setTimeout (
			() => {
				if ( document.querySelector( '.figure-type.out_of_boundary' ) && document.getElementById( 'out_of_boundary' ) ) {
					var outOfBoundary = document.querySelector( ".figure-type.out_of_boundary" ).getBoundingClientRect().left;
					document.querySelector( '.image-type.out_of_boundary' )[0].style.marginLeft = "-" + outOfBoundary + "px";
					document.querySelector( '.image-type.out_of_boundary' )[0].style.opacity = "1";
				}
			}, 100
		);
		if( hasClass )
			target.parentElement.classList.remove( classname );
		else {
			//var elems = document.querySelectorAll( 'div.' + classname );
			var elems = document.querySelectorAll( 'div.accordion__repeater__notab' );
			[].forEach.call( elems, function( el ) {
				el.classList.remove( classname );
			});
			target.parentElement.classList.add( classname );
			this.ngAfterViewInit();
		}
		if ( this.isMobile ) {
			setTimeout( () => {
				const scrollElement = document.querySelector( '.' + classname );
				const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
				let yOffset;

				yOffset = -60;
				window.scrollTo({
					top: yCoordinate + yOffset,
					behavior: 'smooth'
				});
			}, 1 );
		}
	}

	goToLoginPage() {
		document.getElementById( 'pageaccountclick' ).click();
	}
}